import {
  Box, Typography, IconButton, Collapse, List, ListItem, ListItemText,
  ListItemIcon, ListItemButton, Chip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Colors } from "../../Theme/Theme";

export default function SideBarItem({
  Icon, title, active, index, onClick, menuList = [],
  activeSideBar, setActiveSideBar, url, key, isInsurance, comingSoon,
}) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleNavigation = () => {
    if (comingSoon) return;
    if (onClick) onClick();
    navigate(url);
  };
  const handleToggle = (e) => { e.stopPropagation(); setOpen(!open); };

  const greenActive = isInsurance && active;
  const activeBg = greenActive ? Colors.greenSoft : Colors.blueSoft;
  const activeColor = greenActive ? Colors.insuranceGreen : Colors.primary;

  return (
    <>
      <ListItem key={key} disablePadding sx={{ mb: 0.25 }}>
        <ListItemButton
          sx={{
            py: 1, px: 2, gap: 1.5, borderRadius: "8px", mx: 1,
            backgroundColor: active ? activeBg : "transparent",
            borderLeft: "none",
            opacity: comingSoon ? 0.5 : 1,
            transition: "all 0.15s ease",
            "&:hover": {
              backgroundColor: isInsurance ? Colors.greenSoft : Colors.bgColor,
            },
          }}
          onClick={handleNavigation}
        >
          <ListItemIcon sx={{ minWidth: 22, height: 22, color: active ? activeColor : Colors.secondaryColor }}>
            <span style={{ color: "inherit", display: "flex", alignItems: "center" }}>{Icon}</span>
          </ListItemIcon>
          <ListItemText
            primary={
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                <Typography sx={{ fontWeight: active ? 600 : 500, fontSize: "13px", color: active ? Colors.primaryTextColor : Colors.secondaryColor }}>
                  {title}
                </Typography>
                {comingSoon && (
                  <Chip label="Soon" size="small" sx={{
                    height: 16, fontSize: "8px", fontWeight: 700,
                    backgroundColor: Colors.warning, color: Colors.white,
                    "& .MuiChip-label": { px: 0.5 },
                  }} />
                )}
              </Box>
            }
          />
          {menuList.length > 0 && (
            <IconButton size="small" onClick={handleToggle} sx={{ transform: open ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s", color: Colors.light_gray, p: 0.3 }}>
              <ExpandMoreIcon sx={{ fontSize: 18 }} />
            </IconButton>
          )}
        </ListItemButton>
      </ListItem>
      {menuList.length > 0 && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ pl: 4, pr: 1 }}>
            {menuList.map((item, idx) => (
              <ListItem key={idx} disablePadding>
                <ListItemButton sx={{ py: 0.5, borderRadius: "6px", mx: 1, "&:hover": { backgroundColor: Colors.bgColor } }}>
                  <ListItemIcon sx={{ minWidth: 20 }}>
                    <Box sx={{ width: 4, height: 4, borderRadius: "50%", backgroundColor: Colors.light_gray }} />
                  </ListItemIcon>
                  <ListItemText primary={<Typography sx={{ fontSize: "12px", color: Colors.secondaryColor }}>{item}</Typography>} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
}
